<template lang='pug'>
  i.svg-icon.svg-icon-epro
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')

      path(fill="#48B8A8" d="M84.11,43.56c1.94,0,3.75,0.72,5.44,2.15c1.68,1.43,2.53,3.28,2.53,5.54c0,2.39-0.84,4.17-2.53,5.37 c-1.68,1.31-3.5,1.97-5.44,1.97H59.25v23.43c-0.13,4.41-1.04,7.39-2.72,8.94c-1.55,1.43-3.56,2.15-6.02,2.15 c-2.46,0-4.34-0.77-5.63-2.33c-1.3-1.55-1.94-4.47-1.94-8.76V58.58H16.71c-2.33,0-4.15-0.77-5.44-2.33 c-1.55-1.55-2.33-3.28-2.33-5.19c0-2.03,0.65-3.81,1.94-5.36c1.42-1.43,3.37-2.15,5.83-2.15h26.22V16.73c0-3.34,0.78-5.72,2.33-7.15 c1.68-1.43,3.69-2.15,6.02-2.15c2.2,0,4.08,0.72,5.63,2.15s2.33,3.82,2.33,7.15v26.83H84.11z")

</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};
</script>
